import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  TemplateRef
} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit, OnDestroy {
  /**
   * Variable que define el estado del componente.
   * True si está cargando y false cuando haya terminado.
   * Esta propiedad viene del padre que tenga incluido el LoadingComponent.
   */
  @Input() loading;

  /**
   * Tiempo específicado para definir que hubo un timeout
   */
  @Input() timeoutTime;

  /**
   * Esta propiedad contiene la referencia del template creado en el html del LoadingComponent.
   * Con está propiedad se accede al modal y puede abrirse y cerrarse
   */
  modalRef: BsModalRef;
  @ViewChild('template', { static: true }) modalTemplate: TemplateRef<any>;

  /**
   * Variable que contiene el Interval correspondiente al conteo de segundos en el componente para avisar un timeout
   */
  timeoutCounter;

  /**
   * Numero que dice el numero de segundos transcurridos desde que se abrió el componente loading
   */
  timer: number;

  constructor(private modalService: BsModalService) {}

  /**
   * Inicialización de variables
   */
  ngOnInit() {
    this.timer = 0;
    this.timeoutCounter = setInterval(() => {
      if (!this.loading) {
        clearInterval(this.timeoutCounter);
      }
      this.timer++;
      if (this.timer === this.timeoutTime) {
        this.connectionTimeOut();
        clearInterval(this.timeoutCounter);
      }
    }, 1000);
  }

  /**
   * Limpia el interval del timeout de espera del loading cuando se cierra el componente.
   */
  ngOnDestroy() {
    clearInterval(this.timeoutCounter);
  }

  /**
   * Abre un modal avisando que hay fallos en la conexión o el servidor se demoró demasiado en responder.
   * El tiempo para que se abra lo define la variable timeoutTime
   */
  connectionTimeOut() {
    this.open(this.modalTemplate);
    return null;
  }

  /**
   * Abre un modal con un botón para recargar la pantalla y volver a intentarlo porque el servidor se demoró mucho en procesar la petición o porque se demoró mucho.
   * @param content El objeto del modal
   */
  open(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  /**
   * Recarga la ventana (Como si se diera F5 en el teclado).
   */
  reload() {
    location.reload();
  }
}
